<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    />
    <v-row>
      <v-col cols="12" sm="12">
        <parceiro-list-filtro @search="handleGetReport" />
      </v-col>
    </v-row>

    <v-card class="pa-2 mt-5">
      <v-tabs v-model="tab">
        <v-tab href="#listagem" @change="carregarConteudo('listagem')"
          >Serviços Realizado</v-tab
        >
        <v-tabs-items v-model="tab" class="mt-2">
          <v-tab-item eager value="listagem">
            <v-row>
              <v-col cols="12" sm="12">
                <BaseCard>
                  <listagem-relatorio-parceiro
                    ref="listagem"
                  ></listagem-relatorio-parceiro>
                </BaseCard>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import ParceiroListFiltro from '@/components/financeiro/parceiros/relatorio/ParceiroListFiltro.vue'
import ListagemRelatorioParceiro from '@/components/financeiro/parceiros/relatorio/Listagem.vue'
import {mapState} from 'vuex'

import { toReal, parseDatetime } from '@/mixins/convertion.js'
export default {
  name: 'ParceirosRelatorio',

  components: {
    ListagemRelatorioParceiro,
    ParceiroListFiltro,
  },
  mixins: [toReal, parseDatetime],
  data() {
    return {
      parceiro: {},
      tab: 'listagem',
      page: {
        title: 'Relatório de Parceiros',
      },
      breadcrumbs: [
        {
          text: 'Financeiro',
          disabled: true,
        },
        {
          text: 'Parceiros',
          disabled: true,
        },
        {
          text: 'Relatório',
          disabled: false,
        },
      ],
    }
  },
  created() {
      this.parceiro = this.empresaAtual.gate ? {} : this.empresaAtual
  },
  computed: {
    ...mapState('auth', ['empresaAtual']),
  },
  methods: {
    async carregarConteudo(tab) {
      this.tab = tab
      await this.$refs[tab].getReport()
    },
    async handleGetReport() {
      await this.carregarConteudo(this.tab)
    },
  },
}
</script>
